import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import * as identity from '../identity/identityContract';

/**
 * Top-right user menu. Account/tenant administration lives here (vault decision
 * 2026-07-14-capture-ui-navigation-ia — Library parity: settings under the user
 * name), moved out of the nav "Settings ▾" dropdown. Gating is unchanged from
 * the nav placement: Users is admin-only, Departments is builders
 * (admin || power_user), Account is ungated. As in Navigation, hiding is
 * affordance only — the server enforces.
 *
 * Reuses the header's .nav-dropdown hover pattern (right-aligned variant).
 */
export default function UserMenu() {
  const { user, signOut } = useAuth();
  const location = useLocation();

  const [isAdmin, setIsAdmin] = useState(false);
  const [canBuild, setCanBuild] = useState(false);
  useEffect(() => {
    let active = true;
    identity.whoAmI().then((r) => {
      if (active && r.ok) {
        setIsAdmin(r.data.role === 'admin');
        setCanBuild(['admin', 'power_user'].includes(r.data.role));
      }
    });
    return () => { active = false; };
  }, []);

  if (!user) return null;

  return (
    <div className="nav-dropdown user-menu-dropdown">
      <button className="nav-dropdown-trigger">{user.email} ▾</button>
      <div className="nav-dropdown-menu">
        <Link
          to="/settings/account"
          className={location.pathname === '/settings/account' ? 'active' : ''}
        >
          Account
        </Link>
        {isAdmin && (
          <Link
            to="/settings/users"
            className={location.pathname === '/settings/users' ? 'active' : ''}
          >
            Users
          </Link>
        )}
        {canBuild && (
          <Link
            to="/settings/departments"
            className={location.pathname === '/settings/departments' ? 'active' : ''}
          >
            Departments
          </Link>
        )}
        <button onClick={signOut} className="user-menu-signout">
          Sign Out
        </button>
      </div>
    </div>
  );
}
